const state = {
  pxreport: [],
};

export default state;
